// `document.baseURI` matches what the predecessor `LinkActions` class captured at
// construction time — the old betslip store initialized `server.config.baseUrl` to
// `document.baseURI` and `replaceServer(...)` never overwrote it in any production
// path. Reading per-call is functionally equivalent under standard Remix deployments
// and is robust to a runtime <base href> change. If a future deployment mounts the
// app behind a reverse proxy that rewrites the document base, that is the moment to
// inject a server-resolved URL here.
export function clickout(url: string, bookie: string, type: string, isClickout = false): void {
  if (typeof window === 'undefined') return;

  // @ts-ignore — WebViewBridge is injected by the native wrapper app
  if (!window.WebViewBridge) {
    const target = isClickout ? bookie : '_self';
    window.open(url, target);
    return;
  }

  const baseUrl = document.baseURI;
  const formattedUrl = url.indexOf(baseUrl) !== -1 ? url : baseUrl + url;
  // @ts-ignore — postMessage signature differs in the native wrapper
  window.postMessage(`oc.url.clickout::${formattedUrl}::${type}`);
}
